import moment from 'moment';
import db from '../../config/databases/forms';
import updateFormStatus from './updateFormStatus';
import { STATUS as statusList, LOCALSTATUS as localStatusList } from '../../config';

const { to_send } = localStatusList;
const { in_progress } = statusList;

export default async function saveValue(formId, path, value, changeStatus = false) {
  const _formId = parseInt(formId, 10);
  const update = { [path]: value };
  const path_main = path.split('.');
  if (path_main.pop() === 'value') {
    update[`${path_main.join('.')}.timestamp`] = moment().format('YYYY-MM-DD HH:mm:ss');
  }
  await db.table('forms').update(_formId, update);
  if (changeStatus) {
    await updateFormStatus(_formId, in_progress, 'status');
    await updateFormStatus(_formId, to_send, 'localStatus');
  }
}
